import { storage } from '@itau-loans-www/utils'

import common from '../common/consignado'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default (key) => {
  const hasINSSOffer = storage.session.getItem(`${storageName}_leadData`)
    ?.tracking?.hasINSSOffer

  const commonParameters = common()

  const payloadsMap = {
    consignado: {
      custom_path: '/emprestimo/consignado/home',
      ...commonParameters
    },
    proposal: {
      custom_path: '/emprestimo/consignado/dados-iniciais',
      ...commonParameters
    },
    desiredLoanData: {
      custom_path: '/emprestimo/consignado/valor',
      ...commonParameters
    },
    selectOccupation: {
      custom_path: '/emprestimo/consignado/fonte-de-renda',
      ...commonParameters
    },
    AgreementInputNumber: {
      custom_path: '/emprestimo/consignado/autorizacao/inss-informar-numero',
      ...commonParameters
    },
    AgreementWithoutInputNumber: {
      custom_path: '/emprestimo/consignado/autorizacao/inss-sem-numero',
      ...commonParameters
    },
    smsCodeVerification: {
      custom_path: '/emprestimo/consignado/token',
      ...commonParameters
    },
    offers: {
      custom_path: `/emprestimo/consignado/${
        hasINSSOffer ? 'com-oferta' : 'sem-oferta'
      }`,
      ...commonParameters
    },
    pendingOfferFormalization: {
      custom_path: '/emprestimo/consignado/proposta-pendente/nao-finalizada',
      ...commonParameters
    },
    pendingOfferPhotoError: {
      custom_path: '/emprestimo/consignado/proposta-pendente/foto',
      ...commonParameters
    },
    pendingOfferError: {
      custom_path: '/emprestimo/consignado/proposta-pendente/erro',
      ...commonParameters
    },
    blockedBenefit: {
      custom_path: '/emprestimo/consignado/proposta-bloqueada',
      ...commonParameters
    },
    FormalizationPersonalDataConsig: {
      custom_path: '/emprestimo/consignado/formalizacao/dados-pessoais',
      ...commonParameters
    },
    FormalizationDocumentConsig: {
      custom_path: '/emprestimo/consignado/formalizacao/documento',
      ...commonParameters
    },
    FormalizationAddressConsig: {
      custom_path: '/emprestimo/consignado/formalizacao/endereco',
      ...commonParameters
    },
    FormalizationBankingConsig: {
      custom_path: '/emprestimo/consignado/formalizacao/dados-bancarios',
      ...commonParameters
    },
    FormalizationFinishedConsigNcor: {
      custom_path: '/emprestimo/consignado/formalizacao/sucesso',
      ...commonParameters
    },
    resultadoConsignadoSuccess: {
      custom_path: '/emprestimo/consignado/finalizacao/ep-op',
      ...commonParameters
    },
    resultadoReneg: {
      custom_path: '/emprestimo/consignado/finalizacao/renegociacao',
      ...commonParameters
    },
    resultadoRecovery: {
      custom_path: '/emprestimo/consignado/finalizacao/recovery',
      ...commonParameters
    },
    resultadoCGI: {
      custom_path: '/emprestimo/consignado/finalizacao/cgi',
      ...commonParameters
    },
    resultadoPaoDeAcucarCard: {
      custom_path: '/emprestimo/consignado/finalizacao/cartao-pda',
      ...commonParameters
    },
    resultadoItauAccount: {
      custom_path: '/emprestimo/consignado/finalizacao/conta-itau',
      ...commonParameters
    }
  }

  return payloadsMap[key] ?? {}
}
